import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import fr from 'facet-rest';
import Title from 'Components/ComponentLibrary/Atoms/Text/Title';
import Subtitle from 'Components/ComponentLibrary/Atoms/Text/Subtitle';
import { wizardClasses } from 'Views/Page/Content/Templates/WizardTemplates/wizardCommonStyles';
import RichTextDisplay from 'Components/UI/RichTextDisplay';

const useStyles = buildUseStyles('NonAcatConfirmationTemplateContent', (theme) => ({
  root: {
    ...wizardClasses.root(theme),
  },
  container: {
    ...wizardClasses.container(theme),
  },
  content: {
    ...wizardClasses.content(theme),
  },
  gap: {
    marginBottom: theme.spacing(2),
  },
  logo: {
    height: 90,
  },
  infoItem: {
    marginBottom: theme.spacing(1),
    minWidth: 0,
  },
  title: {
    marginBottom: theme.spacing(4),
  },
  info: {
    width: '100%',
    display: 'grid',
    backgroundColor: theme.palette.facet.backgroundGray,
    padding: theme.spacing(2),
    gridTemplateColumns: 'repeat(2, 50%)',
  },
  infoField: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    marginRight: theme.spacing(1),
  },
  combinedField: {
    display: 'flex',
    flexDirection: 'row',
  },
  ellipsisContainer: {
    minWidth: 0,
  },
  ellipsis: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));

const NonAcatConfirmationTemplateContent = ({
  className,
  resource,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const logoSrc = resource.relationship(fr.relationships.facetIcon.name).link('related').url();

  return (
    <Box className={classNames(classes.root, className)}>
      <Box className={classes.container}>
        <Box className={classes.content}>
          <img
            className={classNames(classes.logo, classes.gap)}
            src={logoSrc}
            alt={'facet-logo'}
          />
          <Title
            className={classes.title}
            text={resource.attr('title')}
          />
          <Subtitle
            className={classes.title}
            text={resource.attr('subtitle')}
            weight={'medium'}
          />
          <RichTextDisplay
            className={classes.subtitles}
            content={resource.attr('additionalDetailItems')}
            classes={{ text: classes.subtitleText }}
            variant="h6"
          />
        </Box>
      </Box>
    </Box>
  );
};

NonAcatConfirmationTemplateContent.defaultProps = {
  className: '',
};

NonAcatConfirmationTemplateContent.propTypes = {
  className: PropTypes.string,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default NonAcatConfirmationTemplateContent;
